import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Public litter bin, ~0.9 m: a dark green-grey cylinder on a low plinth with
// a thin band and a darker domed lid.
const BIN = "#556056";
const BIN_DARK = "#3e463f";
const BLACK = "#2e2e30";

export const trashCan = defineModel({
  id: "trash-can",
  batchId: "modern",
  name: "Trash can",
  tags: ["modern", "outdoor", "street", "park", "bin", "waste"],
  summary: "A public litter bin with a domed lid.",
  description:
    "A public litter bin of the Modern Living kit: a dark green-grey " +
    "cylindrical body on a low plinth, a thin darker band and a domed lid. " +
    "About 0.9 m high, freestanding.",
  tiles: { w: 1, h: 1 },
  footprint: 0.65,
  parts(): Part[] {
    return [
      // Plinth.
      {
        geometry: new THREE.CylinderGeometry(0.19, 0.21, 0.08, 12),
        color: BLACK,
        position: [0, 0.04, 0],
      },
      // Body.
      {
        geometry: new THREE.CylinderGeometry(0.22, 0.2, 0.66, 12),
        color: BIN,
        position: [0, 0.41, 0],
      },
      // Thin darker band.
      {
        geometry: new THREE.CylinderGeometry(0.225, 0.225, 0.05, 12),
        color: BIN_DARK,
        position: [0, 0.6, 0],
      },
      // Domed lid.
      {
        geometry: new THREE.SphereGeometry(0.225, 12, 6),
        color: BIN_DARK,
        position: [0, 0.74, 0],
        scale: [1, 0.55, 1],
      },
    ];
  },
  animations: [],
});
